
import {Component, Vue} from 'vue-property-decorator'
import CourierInfo from '@/model/modules/CourierInfo'
import ModuleOrderManage from '@/views/module-order-manage/index.vue'
import UserInfo from '@/model/modules/UserInfo'

@Component({
  components: {ModuleOrderManage}
})
export default class UserOrderObserver extends Vue {
  item: UserInfo = new UserInfo()
  showState: boolean = false
  dataLoadingState: boolean = false

  mounted() {
  }

  showObserver(item: UserInfo) {
    this.item = JSON.parse(JSON.stringify(item))
    this.showState = true
    setTimeout(() => {
      // @ts-ignore
      this.$refs.moduleOrderManage.refreshAllData(item.id)
    }, 100)
  }
}
